module.exports = __webpack_public_path__ + "img/noInfo.4a22ed0a.svg";